import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const usePlanOrderOptionSelectModalControls = () => {
    const { isModalOpen, closeModal, openModal, editModal } = useBrowserModalControls('plan-order-selection');

    return {
        isPlanOrderSelectModalOpen: isModalOpen,
        openPlanOrderOptionSelectModal: () => openModal(),
        closePlanOrderOptionSelectModal: closeModal,
        editPlanOrderOptionSelectModal: editModal,
    };
};
